import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1c6d678"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "social-networks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SocialLink = _resolveComponent("SocialLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SocialLink, {
      name: "GitHub",
      to: "https://github.com",
      icon: "github.svg"
    }),
    _createVNode(_component_SocialLink, {
      name: "Twitter",
      to: "https://twitter.com",
      icon: "twitter.svg"
    }),
    _createVNode(_component_SocialLink, {
      name: "FaceBook",
      to: "https://faceBook.com",
      icon: "facebook.svg"
    })
  ]))
}